<template>
  <div id="playbook">
    <div class="commonContainer">
      <div class="filterConditionContainer">
        <el-card class="box-card">
          <div class="filterCondition" >
            <div class="searchIcon">
              <i class="el-icon-search"></i>
            </div>
            <el-form :inline="true" :model="filterForm" class="filterForm" label-width="98px">
              <el-form-item :label="$t('information.createTime')" >
                <el-date-picker
                  v-model="filterForm.createTime"
                  type="daterange"
                  range-separator="-"
                  :start-placeholder="$t('survey.startTime')"
                  :end-placeholder="$t('survey.endTime')"
                  value-format="yyyy-MM-dd"
                  align="right">
                </el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('information.fileName')" >
                <el-input v-model="filterForm.fileName" :placeholder="$t('information.enterFileName')"></el-input>
              </el-form-item>
            </el-form>
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="20">
                <div class="filterBtns">
                  <!--
                  <el-button type="primary" @click="importData">导 入</el-button>
                  <el-button type="primary" @click="exportData">导 出</el-button>
                  -->
                  <!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                  <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                  <el-button type="primary" @click="onReset()">{{ $t('reset') }}</el-button>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="filterBtns">
                  <el-button type="primary" @click="onAdd">{{ $t('add') }}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
          </div>
          <div style="margin-top: 20px">
            <el-table :data="tableData" v-loading="tableLoading">
              <el-table-column sortable prop="fileName" :label="$t('information.fileName')"></el-table-column>
              <el-table-column sortable prop="createTime" :label="$t('information.createTime')"></el-table-column>
              <el-table-column :label="$t('operation')">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="openDetail(scope.row.fileUrl)">{{ $t('see') }}</el-button>
                  <el-button type="text" size="mini" @click="openEdit(scope.row)">{{ $t('edit') }}</el-button>
<!--                  <el-button type="text" size="mini" @click="openCondition(scope.row.id, scope.row.fileRange)">{{ $t('information.condition') }}</el-button>-->
                  <el-button type="text" size="mini" @click="deleteBook(scope.row.id)">{{ $t('delete') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination
                background
                @current-change="currentChange"
                :current-page="tableConfig.current"
                layout="total, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <el-dialog
      :title="$t('information.condition')"
      :visible.sync="conditionDialogVisible"
      width="40%"
      center
    >
      <div style="text-align: center">
        <el-radio v-model="condition" :label="1">ND</el-radio>
        <el-radio v-model="condition" :label="2">NSP</el-radio>
      </div>

      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitCondition">{{ $t('save') }}</el-button>
          <el-button type="primary" @click="cancelCondition">{{ $t('cancel') }}</el-button>
        </span>
    </el-dialog>
    <el-dialog
      :title="operation"
      :visible.sync="editDialogVisible"
      width="40%"
      center
    >
      <el-form ref="form" :model="fileForm" label-width="80px">
        <anyImageUpload
          label="封面图片"
          labelWidth="80"
          v-model="fileForm.coverImage"
        />
        <el-form-item :label="$t('information.fileName')">
          <el-input v-model="fileForm.fileName"></el-input>
        </el-form-item>
      </el-form>

      <div style="text-align: center">
        <el-upload
          class="upload-demo"
          drag
          :action="attachmentsUploadUrl"
          :limit="1"
          :on-success="onSuccess"
          :on-remove="onRemove"
          :headers="header"
          :file-list="fileList"
          accept=".pdf"
          >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传pdf文件，且不超过500M</div>
        </el-upload>

      </div>



      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitFile">{{ $t('save') }}</el-button>
          <el-button type="primary" @click="cancelFile">{{ $t('cancel') }}</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import anyImageUpload from "@/components/anyImageUpload";

export default {
  name: 'Popup',
  components: {
    anyImageUpload
  },
  data: function () {
    return {
      header: {
        token: CookieManage.get('token') || '', // 用户token
      },
      attachmentsUploadUrl: window.uploadUrl,
      operation: '', // 新增或编辑
      fileList: [],
      // fileList: [{name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}],
      fileForm: {
        fileName: '',
        coverImage: '', // 封面图片
      },
      conditionDialogVisible: false, // 适用范围弹窗
      editDialogVisible: false, // 新增/编辑弹窗
      condition: 1, // 适用范围
      filterForm: {
        fileName: '', // 文件名称
        createTime: [], // 创建时间
      },
      initFilterForm: {
        fileName: '', // 文件名称
        createTime: [], // 创建时间
      },
      loading: false,
      tableData: [], // 表格数据
      total: 0,
      tableConfig: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      tableLoading: false,
      tempId: null, // 打开设置适用范围的id
    }
  },
  mounted () {

  },

  methods: {
    // 成功上传文件的回调
    onSuccess(response, file, fileList) {
      this.fileForm.fileName = this.fileForm.fileName || file.name
      console.log('response', response)
      console.log('file', file)
      console.log('fileList', fileList)
      this.fileList = _.cloneDeep(fileList)
    },

    // 删除文件的回调
    onRemove(file, fileList) {
      console.log('删除')
      this.fileForm.fileName = ''
    },

    onReset() {
      // 重置
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },

    onAdd() {
      // 新增
      this.fileForm = {
        coverImage: '',
        fileName: '',
        fileUrl: ''
      }
      this.fileList = []
      this.editDialogVisible = true
    },
    currentChange: function (index) {
      // 分页
      this.tableConfig.current = index
      this.onSearch(false)
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      this.tableLoading = true
      const submitData = {}
      submitData.fileName = this.filterForm.fileName
      submitData.startDate = this.filterForm.createTime[0] || ''
      submitData.endDate = this.filterForm.createTime[1] || ''

      let res = await window.instance.post(window.retailinkUrl + '/playBook/listPlayBook', _.assign(submitData, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        const list = res.data.records
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },
    openDetail: function(url) {
      // 查看
      window.open(url)
    },
    openEdit: function(row) {
      // 编辑
      this.fileForm.coverImage = row.coverImage
      this.fileForm.fileName = row.fileName
      this.fileList = [{name: row.fileName, response: {data: {url: row.fileUrl}}}]
      this.tempId = row.id
      this.editDialogVisible = true
    },
    openCondition: function(id, condition) {
      // 适用范围
      this.conditionDialogVisible = true
      this.tempId = id
      this.condition = condition
    },
    cancelCondition: function() {
      this.conditionDialogVisible = false;
      this.tempId = null
    },
    submitCondition: async function() {
      let res = await window.instance.post(window.retailinkUrl + '/playBook/setRange/' + this.tempId + '/' + this.condition,);
      res = res.data
      if (res.code === 200) {
        this.$message.success(res.message)
        this.conditionDialogVisible = false;
        this.tempId = null
        await this.onSearch(false);
      } else {

      }
    },
    cancelFile: function() {
      this.editDialogVisible = false
      this.tempId = null
    },
    submitFile: async function() {
      console.log('this.fileForm', this.fileForm)
      console.log('this.fileList', this.fileList)
      if (!this.fileList.length) {
        this.$message.error('请上传文件！')
      }

      const submitData = _.cloneDeep(this.fileForm)
      submitData.fileUrl = this.fileList[0].response.data.url
      let submitUrl = '/playBook/savePlayBook'
      if (!_.isNil(this.tempId)) {
        submitUrl = '/playBook/updatePlayBook'
        submitData.id = this.tempId
      }
      let res = await window.instance.post(window.retailinkUrl + submitUrl, submitData);
      res = res.data
      if (res.code === 200) {
        this.$message.success(res.message)
        this.editDialogVisible = false;
        this.tempId = null
        await this.onSearch(false);
      }
    },
    deleteBook: function(id) {
      // 删除book
      this.$confirm('确定删除该book吗?', '提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await window.instance.post(window.retailinkUrl + '/playBook/delPlayBook/' + id)
        res = res.data
        if (res.code === 200) {
          this.onSearch(true)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    }
  }
}
</script>

<style scoped lang="sass">
#playbook

</style>



// WEBPACK FOOTER //
// src/pages/information/playbook.vue